import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { ActivatedRoute } from '@angular/router';
// import { BrandService } from '../../../services/brand/brand.service';
// import { SharedService } from '../../../services/shared.service';
import { MessagePageService } from '../../../services/message/message-page.service';
// import { ComponentSectionFactoryService } from '../../../services/component-section-factory.service';
// import { HeaderSectionDirective } from '../../../directives/header-section.directive';
// import { FooterSectionDirective } from '../../../directives/footer-section.directive';
// import { IComponentSection } from '../../../interfaces/component-section';
// import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
// import { ThemeDirective } from '../../../directives/theme.directive';
import { NGXLogger } from 'ngx-logger';
import { ISessionDetails } from '../../../interfaces/session-details';

@Component({
    selector: 'app-message-page',
    standalone: true,
    templateUrl: './message-page.component.html',
    styleUrls: ['./message-page.component.css'],
    imports: [
      // ThemeDirective, 
      // HeaderSectionDirective, 
      NgClass, 
      // FooterSectionDirective
    ]
})
export class MessagePageComponent implements OnInit {

  // @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  // @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

    private readonly logger = inject(NGXLogger);
    private readonly dataExchangeService = inject(DataExchangeService);
    private readonly messagePageService = inject(MessagePageService);
    private readonly sanitizer = inject(DomSanitizer);

  brandCode!: string;
  // region!: string;
  // messagePageUuid!: string;
  // moduleName!: string;

  // brandStyleTheme: any = {};

  messageText!: SafeHtml | null;
  messageHeader!: SafeHtml | null;

  isPrimaryMessageShown: boolean = false;
  isSecondaryMessageShown: boolean = false;
  isSuccessMessageShown: boolean = false;
  isDangerMessageShown: boolean = false;
  isWarningMessageShown: boolean = false;
  isInfoMessageShown: boolean = false;

  isDismissibleShown: boolean = false;

  firstButttonLabel!: string | null;
  firstButtonRedirectUrl!: string | null;
  isFirstButttonShown: boolean = false;

  secondButttonLabel!: string | null;
  secondButtonRedirectUrl!: string | null;
  isSecondButttonShown: boolean = false;

  btnCancelUrl!: string;  

  constructor() {
  }

  ngOnInit() {
    // Get the parameters from the caller (Walletron)
    // this.activatedRoute.queryParamMap.subscribe((params) => {
    //   this.region = params.get('r') || '';
    //   this.messagePageUuid = params.get('mi') || '';
    //   this.moduleName = params.get('mo')?.toLowerCase() || '';
    // });
    
    const region: string = this.dataExchangeService.getRegion();
    const session: ISessionDetails = this.dataExchangeService.getSession();
    let module: string;
    switch (session.module) {
      case 'WALLETRON':
        module = 'Walletron';
        break;
      default:
        module = session.module.toLowerCase();
        break;
    }
    this.logger.log(`MessagePageComponent - ngOnInit: region: ${region}, sessionId: ${session.walPageUuid}, module: ${module}`);
    if (region && session) {
      if (session.options) {
        const options: Map<string, string> = new Map(Object.entries(session.options));
        if (options.has('msgPageUuid')) {
          const messagePageUuid: string = options.get('msgPageUuid') || '';
          this.logger.log(`MessagePageComponent - ngOnInit: module: ${module}, messagePageUuid: ${messagePageUuid}`);
          
          // Retrieve message page details
          if (messagePageUuid) {
            this.getMessagePageDetails(region, module, messagePageUuid);
          }
        }
      }
    }

  }

  getMessagePageDetails(region: string, moduleName: string, messagePageUuid: string) {

    this.messagePageService.getMessagePageDetails(region, moduleName, messagePageUuid)
    .subscribe(response => {
      if (response) {
        console.log('getMessagePageDetails - response', response);

        // Display the message header, if it is specified
        if (response.options && response.options.has('msgHeader')) {
          const rawHeader = response.options.get('msgHeader') ?? null;
          this.messageHeader = rawHeader ? this.sanitizer.bypassSecurityTrustHtml(rawHeader) : null;
        }

        // Display the message
        if (response.messageText) {
          this.messageText = this.sanitizer.bypassSecurityTrustHtml(response.messageText);
        } else if (response.options && response.options.has('msgText')) {
          const rawText = response.options.get('msgText') ?? null;
          this.messageText = rawText ? this.sanitizer.bypassSecurityTrustHtml(rawText) : null;
        }

        // Figure out severity type of the message
        if (response.options && response.options.has('severity')) {
          switch(response.options.get('severity')) {
            case 'PRIMARY':
              this.isPrimaryMessageShown = true;
              break;
            case 'SECONDARY':
              this.isSecondaryMessageShown = true;
              break;
            case 'SUCCESS':
              this.isSuccessMessageShown = true;
              break;
            case 'DANGER':
            case 'ERROR':
            case 'FAILURE':
              this.isDangerMessageShown = true;
              break;
            case 'INFO':
              this.isInfoMessageShown = true;
              break;
            case 'WARNING':
              this.isWarningMessageShown = true;
              break;
          }
        } else {
          this.isInfoMessageShown = true;
        }

        // Is the dialog dismissible?
        if (response.options && response.options.has('dismissible')) {
          this.isDismissibleShown = (response.options.get('dismissible')?.toLowerCase() === 'true');
        }

        // Is there first button configured?
        if (response.options && response.options.has('button1Label') && response.options.has('button1Visible')) {
          this.firstButttonLabel = response.options.get('button1Label') ?? null;
          this.firstButtonRedirectUrl = response.options.get('button1Url') ?? null;
          this.isFirstButttonShown = (response.options.get('button1Visible')?.toLowerCase() === 'true');
        }

        // Is there second button configured?
        if (response.options && response.options.has('button2Label') && response.options.has('button2Visible')) {
          this.secondButttonLabel = response.options.get('button2Label') ?? null;
          this.secondButtonRedirectUrl = response.options.get('button2Url') ?? null;
          this.isSecondButttonShown = (response.options.get('button2Visible')?.toLowerCase() === 'true');
        }

        // In case no button is defined in the Options, then display a simple Close button
        if (!this.isFirstButttonShown && !this.isSecondButttonShown) {
          this.secondButttonLabel = 'Close';
          this.isSecondButttonShown = true;
        }

        // Figure out the URL for exiting the form
        if (response.options && response.options.has('cancelUrl')) {
          this.btnCancelUrl = response.options.get('cancelUrl') ?? 'https://www.aciworldwide.com';
        } else {
          this.btnCancelUrl = 'https://www.aciworldwide.com';
        }

        // Create form header and footer
        this.brandCode = response.brandCode;
        // this.makeHeaderAndFooter();

        console.log('messageHeader',this.messageHeader);
        console.log('messageText',this.messageText);
      }
      // console.log('getMessagePageDetails - messageHeader', this.messageHeader);
      // console.log('getMessagePageDetails - messageText', this.messageText);
      // console.log('getMessagePageDetails - firstButttonLabel', this.firstButttonLabel);

    });
  }

  // makeHeaderAndFooter() {
  //   this.brandService.getBrandInfo(this.region, this.brandCode, "NPE,WAL_PAGES,EAUTH")
  //   .subscribe(response => {
  //     if (response) {
  //       this.brandStyleTheme = this.sharedService.getBrandStyleScheme(response);
  //       // console.log('brandStyleTheme', this.brandStyleTheme);
  //       // this.loadHeaderSection(response);
  //       // this.loadFooterSection(response);
  //       this.componentSectionFactoryService.loadHeaderSection(response, this.headerComponentSection);
  //       this.componentSectionFactoryService.loadFooterSection(response, this.footerComponentSection);
  //     }
  //   });
  // }


  onCancel() {
    window.location.href = this.btnCancelUrl;
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

  onFirstButtonClick() {
    if (this.firstButtonRedirectUrl) {
      window.open(this.firstButtonRedirectUrl, '_blank');
    } else {
      window.open('','_parent','');
      window.close();
    }
  }

  onSecondButtonClick() {
    if (this.secondButtonRedirectUrl) {
      window.open(this.secondButtonRedirectUrl, '_blank');
    } else {
      window.open('','_parent','');
      window.close();
    }
  }

}
